import React, { useEffect, useState } from 'react';

import { useParams } from 'react-router-dom';
import { addAppToProduct } from './ProductService';
import { getAllApps } from '../Apps/AppService';
// import { getAllItems } from '../Items/ItemService';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import OutlinedInput from '@mui/material/OutlinedInput';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { notify } from 'utils/notify';
import { extractErrorMessage } from 'utils/extractErrorMessage';
// import appProgrammeList from './AppProgrammeList'
//import listProductItems from './ProductAppList';

const AttachApp = ({ listProductApps }) => {
  const [open, setOpen] = useState(false);
  const [items, setItems] = useState<any[]>([]);

  const [selectedAppId, setSelectedAppId] = useState(null);

  const { productid } = useParams();

  const handleChange = (appid) => {
    setSelectedAppId(appid);
  };

  const handleClickOpen = () => {
    listProductApps();
    setOpen(true);
  };

  const handleClose = (event, reason) => {
    if (reason !== 'backdropClick') {
      setOpen(false);
    }
  };

  useEffect(() => {
    listApps();
  }, []);

  function listApps() {
    //const nextItemId = parseInt(sectionId) +1;
    //const nextItemId = 1;
    getAllApps()
      .then((response) => {
        setItems(response.data);
      })
      .catch((error) => {
        console.error(error);
        notify(extractErrorMessage(error));
      });
  }

  function attachSelectedItem(appid, productid) {
    addAppToProduct(productid, appid)
      .then(() => {
        // appProgrammeList();
        listProductApps();
        handleClose(null, null);
      })
      .catch((error) => {
        console.error(error);
        notify(extractErrorMessage(error));
      });
  }

  return (
    <div>
      <Button onClick={handleClickOpen}>Select App</Button>
      <Dialog disableEscapeKeyDown open={open}>
        <DialogTitle>Select</DialogTitle>
        <DialogContent>
          <Box component="form" sx={{ display: 'flex', flexWrap: 'wrap' }}>
            <FormControl sx={{ m: 1, minWidth: 120 }}>
              {/* <InputLabel htmlFor="demo-dialog-native">Name</InputLabel> */}
              <Select
                native
                value={selectedAppId || ''} // Use selectedAppId as the value
                onChange={(e) => handleChange(e.target.value)}
                input={
                  <OutlinedInput label="Select User" id="demo-dialog-native" />
                }
              >
                {/* Ensure "Select Item" option is selected by default */}
                <option value={''} disabled>
                  Select App
                </option>
                {/* Map over items to generate options */}
                {items.map((item) => (
                  <option key={item.id} value={item.id}>
                    {item.appName}
                  </option>
                ))}
              </Select>
            </FormControl>
          </Box>
        </DialogContent>
        <DialogActions>
          {/* <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={addProgrammeAssignment(progid, selectedProgrammeId)}>Add</Button> */}
          <Button onClick={() => handleClose(null, null)}>Cancel</Button>
          <Button onClick={() => attachSelectedItem(selectedAppId, productid)}>
            Add
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default AttachApp;
